import autosize from 'autosize';
import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/remind-assignee-form.scss';

Component('tr-remind-assignee-form', {
  mixins: [eventListenerMixin],

  properties: {
    createTodoUrl: String,
  },

  ready() {
    this.initContentField();
    const submitBtn = this.querySelector('.buttons .submit');
    this.listenTo(submitBtn, 'click', this.handleSubmitForm.bind(this));
  },

  initContentField() {
    this.contentInput = this.querySelector('.content-field textarea');
    this.contentInput.rows = 1;
    autosize(this.contentInput);
    this.contentInput.focus();

    const { length: selectionOffset } = this.contentInput.value;
    this.contentInput.setSelectionRange(selectionOffset, selectionOffset);
  },

  parseDate(dates) {
    let startAt;
    let dueAt;
    if (dates.length === 2) {
      [startAt, dueAt] = dates;
    } else {
      startAt = null;
      [dueAt] = dates;
    }
    return [startAt, dueAt];
  },

  handleSubmitForm() {
    if (!this.contentInput.value) return;

    const assigneeValue = this.querySelector('.assignee-select-field tr-selector-field').getValue();
    const dateFieldValues = this.querySelector('.date-select-field tr-todo-date-field').getValue().split(',');
    const [startAt, dueAt] = this.parseDate(dateFieldValues);

    $.ajax({
      url: this.createTodoUrl,
      type: 'post',
      dataType: 'script',
      data: {
        todos_creation: {
          content: this.contentInput.value,
          assignee_guid: assigneeValue,
          start_at: startAt,
          due_at: dueAt,
        },
      },
    });
  },
});
